export const Defaults = {
    'CloseDialog': 'Close dialog',
    'CloseAll': 'Close all documents',
    'CloseAllButThis': 'Close all documents but this',
    'DefaultPanelName': 'Panel',
    'NewBrowserWindow': 'Open in new window'
    //Example of parameterized translation
    // 'CloseWithName': 'Close tab {0}'
};
//# sourceMappingURL=Defaults.js.map